export default __webpack_public_path__ + "static/media/imovel.fbb25d3e.png";